import React from 'react';
import { useLanguage } from './LanguageContext';

const RTLProvider = ({ children }) => {
  const { language } = useLanguage();
  
  React.useEffect(() => {
    // Установка направления текста для всего документа
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    // Добавление/удаление класса для RTL стилей
    document.documentElement.classList.toggle('rtl', language === 'ar');
  }, [language]);

  return (
    <div className={`${language === 'ar' ? 'rtl' : ''}`}>
      {children}
    </div>
  );
};

export default RTLProvider;